// extracted by mini-css-extract-plugin
export var container = "EditDetails-module--container--Al9ST";
export var content = "EditDetails-module--content--Ft+K5";
export var footer = "EditDetails-module--footer--oFCuB";
export var input = "EditDetails-module--input--Hcr5S";
export var title = "EditDetails-module--title--ddGOx";